type SiweMessage = {
  domain: string
  address: string
  statement: string
  uri: string
  version: string
  chainId: string
  nonce: string
  issuedAt: string
}

// Regex patterns for parsing SIWE message components
const DOMAIN_REGEX =
  /^(?<domain>[^ ]+) wants you to sign in with your account:$/
const ADDRESS_REGEX =
  /^(?<address>(?:0x[0-9a-fA-F]{40}|[1-9A-HJ-NP-Za-km-z]{32,44}))$/
const STATEMENT_REGEX =
  /^Click to sign in and accept the OpenSea Terms of Service \(https:\/\/opensea.io\/tos\) and Privacy Policy \(https:\/\/opensea.io\/privacy\).$/
const URI_REGEX = /^URI: (?<uri>.+)/
const VERSION_REGEX = /^Version: (?<version>\d+)/
const CHAIN_ID_REGEX = /^Chain ID: (?<chainId>\d+)/
const NONCE_REGEX = /^Nonce: (?<nonce>.+)/
const ISSUED_AT_REGEX = /^Issued At: (?<issuedAt>.+)/

export function parseSiwxMessage(message: string): SiweMessage {
  const lines = message.split("\n")

  const domainMatch = DOMAIN_REGEX.exec(lines[0])
  const addressMatch = ADDRESS_REGEX.exec(lines[1])
  const statementMatch = STATEMENT_REGEX.exec(lines[3])
  const uriMatch = URI_REGEX.exec(lines[5])
  const versionMatch = VERSION_REGEX.exec(lines[6])
  const chainIdMatch = CHAIN_ID_REGEX.exec(lines[7])
  const nonceMatch = NONCE_REGEX.exec(lines[8])
  const issuedAtMatch = ISSUED_AT_REGEX.exec(lines[9])

  return {
    domain: domainMatch ? domainMatch[1] : "",
    address: addressMatch ? addressMatch[0] : "",
    statement: statementMatch ? statementMatch[0] : "",
    uri: uriMatch ? uriMatch[1] : "",
    version: versionMatch ? versionMatch[1] : "",
    chainId: chainIdMatch ? chainIdMatch[1] : "",
    nonce: nonceMatch ? nonceMatch[1] : "",
    issuedAt: issuedAtMatch ? issuedAtMatch[1] : "",
  }
}
